import { useQuery } from 'react-query';
import Users from '../../services/User'
import AttToken from '../../services/AttToken';
import { DataGrid, GridColDef, GridLocaleText } from '@mui/x-data-grid';
import { ptBR } from '@mui/x-data-grid/locales'
import { Button, Skeleton, Stack, Typography } from '@mui/material';
import { useContext, useState } from 'react';
import AddEmpresasModal from './AddEmpresasModal';
import { ToastContainer } from 'react-toastify';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import DomainAddIcon from '@mui/icons-material/DomainAdd';
import { EmpresasContext } from '../../context/EmpresasContext';

const userService = new Users();

export default function UsersList() {
  const { empresas: empresasData, onLoading } = useContext(EmpresasContext);
  const [user, setUser] = useState();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [open, setOpen] = useState<{ id: string, visible: boolean }>({
    id: '',
    visible: false,
  });

  const { data, isLoading } = useQuery({
    queryKey: ['GET_USERS'],
    queryFn: async () => {
      const token = await AttToken()
      if (token) {
        const response = await userService.getAdminUsers(token)
        return response
      }
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    retry: 0,
  })

  const columns: GridColDef[] = [
    { field: 'nome', headerName: 'Nome', width: 150, align: 'center', headerAlign: 'center' },
    { field: 'id', headerName: 'Nome de usuário', width: 150, align: 'center', headerAlign: 'center' },
    {
      field: "empresas",
      align: 'center',
      headerAlign: 'center',
      headerName: "Empresas associadas",
      sortable: false,
      width: 200,
      renderCell: (params) => (
        !params?.row?.empresas?.length ? <>Sem empresas associadas</> :
          <>
            {open.id !== params.id as string
              ? <Button
                sx={{ textTransform: 'none' }}
                color='warning'
                variant='contained'
                endIcon={<VisibilityIcon />}
                disabled={!empresasData}
                onClick={() => setOpen({ id: params.id as string, visible: true })}
              >
                Mostrar empresas
              </Button>
              : <Stack direction='column' justifyContent='center' alignItems='center' spacing={1} padding={.5}>
                <Stack direction={'column'}>
                  {params.row?.empresas?.map((empresaId: string, key: number) => (
                    <div key={key}>{(empresasData as any)?.find((empresa: any) => empresa.id === empresaId).nome}</div>
                  ))}
                </Stack>
                <Button
                  endIcon={<VisibilityOffIcon />}
                  variant='outlined'
                  size='small'
                  sx={{ textTransform: "none" }}
                  onClick={() => setOpen({ id: '', visible: false })}
                >
                  Ocultar
                </Button>
              </Stack>}
          </>
      )
    },
    {
      field: "edit",
      align: 'center',
      headerAlign: 'center',
      headerName: "Editar associação de empresas",
      sortable: false,
      width: 220,
      renderCell: (params) => (
        <Button
          variant='outlined'
          endIcon={<DomainAddIcon />}
          disabled={!empresasData || !data}
          onClick={(event) => {
            event.preventDefault();
            const usuario = data?.find((elem: any) => elem.id === params.id)
            setUser(usuario)
            if (usuario)
              setOpenModal(!openModal)
          }}
        >
          Adicionar empresas
        </Button>
      )
    },
  ];


  const ptBRGrid: Partial<GridLocaleText> = {
    footerRowSelected: (count) =>
      count !== 1
        ? ``
        : ``,
  }

  return (
    <Stack direction='column' alignItems='flex-start' justifyContent='flex-start' width='100%' spacing={2}>
      <ToastContainer />
      <Typography variant='h5' fontWeight={600} color='textDisabled' textAlign='center' width='100%' >Usuários Administradores</Typography>
      {openModal
        && <AddEmpresasModal
          empresas={empresasData}
          isLoading={onLoading}
          openModal={openModal}
          setOpenModal={setOpenModal}
          user={user}
          setUser={setUser}
        />}
      {isLoading
        ? <Skeleton width={'100%'} variant='rounded' height={300} />
        : <DataGrid
          sx={{ '--css-1jlz3st': 'display:  none', width: '100%' }}
          getRowHeight={() => 'auto'}
          autoHeight
          rows={data}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[10, 25]}
          localeText={ptBRGrid && ptBR.components.MuiDataGrid.defaultProps.localeText}
        />
      }
    </Stack>
  )
}
